import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
import React, { useState } from "react";
import "./ParcelCheckinModal.css";

interface ParcelCheckinModalProps {
  onClose: () => void;
  onConfirm: (trackingInfo: {
    trackingNumber: string;
    courier: string;
  }) => void;
}

const ParcelCheckinModal: React.FC<ParcelCheckinModalProps> = ({
  onClose,
  onConfirm,
}) => {
  const [trackingNumber, setTrackingNumber] = useState("");
  const [courier, setCourier] = useState("");

  const handleConfirm = () => {
    onConfirm({ trackingNumber, courier });
  };

  const isFormValid = trackingNumber.trim() !== "" && courier.trim() !== "";

  return (
    <Modal title={<>Double Parcel Check-in</>} onClose={onClose} size="medium">
<div className="modal-content legacy-modal-content" onClick={(e) => e.stopPropagation()}>

        <div className="modal-body">
          <p className="modal-description">
            Enter tracking number for this shipment, and also the name of
            courier service.
          </p>
          <div className="checkin-form">
            <div className="checkin-input-group">
              <label htmlFor="trackingNumber">Tracking Number</label>
              <input
                type="text"
                id="trackingNumber"
                placeholder="Enter tracking number"
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
              />
            </div>
            <div className="checkin-input-group">
              <label htmlFor="courier">Name of Courier Service</label>
              <input
                type="text"
                id="courier"
                placeholder="Enter courier service"
                value={courier}
                onChange={(e) => setCourier(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button type="button" variant="primary"
            className="confirm-btn"
            onClick={handleConfirm}
            disabled={!isFormValid}
          >
            Confirm Check-in
          </Button>
        </div>
      </div>
</Modal>
  );
};

export default ParcelCheckinModal;
